module.exports = __webpack_public_path__ + "img/splash_screen_banner.1116b140.png";